/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contentreports1Inputs */

const en_contentreports1 = /** @type {(inputs: Contentreports1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content Reports`)
};

const de_contentreports1 = /** @type {(inputs: Contentreports1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhaltsmeldungen`)
};

/**
* | output |
* | --- |
* | "Content Reports" |
*
* @param {Contentreports1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const contentreports1 = /** @type {((inputs?: Contentreports1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contentreports1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contentreports1(inputs)
	return de_contentreports1(inputs)
});
export { contentreports1 as "contentReports" }